var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIls15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 740,
    height: 641,
    viewBox: "0 0 740 641",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4869 493.19L121.47 536.004C125.652 538.424 132.435 538.424 136.617 536.004L210.6 493.198C214.783 490.779 214.783 486.853 210.6 484.442L136.678 441.723C132.496 439.304 125.713 439.304 121.53 441.715L47.4956 484.434C43.3043 486.853 43.3043 490.77 47.4869 493.19Z",
    fill: "url(#paint0_linear_470_219)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.539 571.395L382.948 637.597C389.418 641.34 399.905 641.34 406.365 637.597L520.774 571.403C527.244 567.661 527.244 561.594 520.774 557.86L406.461 491.797C399.992 488.054 389.505 488.054 383.026 491.788L268.539 557.86C262.078 561.585 262.07 567.652 268.539 571.395Z",
    fill: "url(#paint1_linear_470_219)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.931 385.792L442.844 426.857C447.191 429.181 454.244 429.181 458.591 426.857L535.505 385.792C539.852 383.468 539.852 379.708 535.505 377.393L458.661 336.415C454.313 334.099 447.261 334.091 442.913 336.415L365.948 377.401C361.583 379.717 361.583 383.477 365.931 385.792Z",
    fill: "url(#paint2_linear_470_219)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.156 344.84L250.417 373.345C253.2 374.956 257.713 374.956 260.504 373.345L309.765 344.84C312.547 343.23 312.547 340.619 309.765 339.008L260.547 310.564C257.765 308.954 253.243 308.954 250.461 310.564L201.165 339.008C198.374 340.619 198.374 343.23 201.156 344.84Z",
    fill: "url(#paint3_linear_470_219)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.565 167.549C186.608 167.332 185.574 167.401 184.591 167.837C184.417 167.906 184.252 167.993 184.087 168.089L182.191 169.177L11.6607 267.758C8.37373 269.655 6.35634 273.163 6.35634 276.949V409.571C6.35634 411.181 6.93895 412.6 7.86939 413.679C8.50417 414.419 9.30417 415.002 10.1911 415.385L5.13895 413.679C4.71286 413.584 4.29547 413.436 3.89547 413.262H3.88678C2.81721 412.774 1.88678 412 1.22591 411.025C0.565039 410.041 0.165039 408.84 0.165039 407.508V274.895C0.165039 271.1 2.19113 267.592 5.46939 265.695L177.904 166.026C179.295 165.217 180.843 165.191 182.156 165.722L182.217 165.748L187.565 167.549Z",
    fill: "url(#paint4_linear_470_219)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.409 172.319V307.866C191.409 311.399 189.53 314.655 186.47 316.422L15.826 415.037C13.9825 416.108 11.9391 416.116 10.2173 415.385L10.1912 415.377C9.30427 414.994 8.49558 414.41 7.86949 413.671C6.93905 412.591 6.35645 411.173 6.35645 409.562V276.94C6.35645 273.154 8.37384 269.647 11.6608 267.749L182.191 169.168L184.087 168.08C184.252 167.985 184.417 167.897 184.591 167.828C185.574 167.401 186.6 167.323 187.565 167.541L188.548 167.871C190.191 168.62 191.409 170.256 191.409 172.319Z",
    fill: "#F3F6FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.104 233.386L52.6084 222.698L52.6605 372.388L34.1562 383.076L34.104 233.386Z",
    fill: "url(#paint5_linear_470_219)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1304 168.246L89.6347 157.888L89.6608 351.028L71.1565 361.725L71.1304 168.246Z",
    fill: "url(#paint6_linear_470_219)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.147 254.737L126.652 244.048L126.678 329.608L108.174 340.305L108.147 254.737Z",
    fill: "url(#paint7_linear_470_219)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145.147 265.451L163.652 254.763L163.678 308.257L145.174 318.946L145.147 265.451Z",
    fill: "url(#paint8_linear_470_219)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M438.686 166.966V190.884L342.452 167.079L270.321 125.326L438.686 166.966Z",
    fill: "url(#paint9_linear_470_219)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.33 375.521L294.356 83.5738L438.678 0.172607V292.12L294.33 375.521Z",
    fill: "url(#paint10_linear_470_219)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M318.399 403.348L318.434 111.4L462.747 27.999V319.947L318.399 403.348Z",
    fill: "url(#paint11_linear_470_219)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M510.852 208.728L438.687 190.885V166.966L510.852 208.728Z",
    fill: "url(#paint12_linear_470_219)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M354.479 424.194L354.505 132.246L498.826 48.845V340.792L354.479 424.194Z",
    fill: "url(#paint13_linear_470_219)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M453.625 109.972L388.313 147.705L389.257 149.341L454.568 111.608L453.625 109.972Z",
    fill: "#B4C9FC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M486.169 109.685L371.878 175.757L372.822 177.393L487.113 111.321L486.169 109.685Z",
    fill: "#B4C9FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M486.168 128.555L371.877 194.626L372.821 196.262L487.112 130.19L486.168 128.555Z",
    fill: "#B4C9FC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M486.169 147.51L371.878 213.582L372.822 215.218L487.113 149.146L486.169 147.51Z",
    fill: "#B4C9FC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M486.166 166.293L371.875 232.365L372.819 234L487.11 167.929L486.166 166.293Z",
    fill: "#B4C9FC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M486.165 185.163L371.874 251.234L372.818 252.87L487.109 186.798L486.165 185.163Z",
    fill: "#B4C9FC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M417.584 89.0844L352.272 126.817L353.216 128.453L418.527 90.7202L417.584 89.0844Z",
    fill: "#B4C9FC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M393.45 61.31L328.139 99.0427L329.082 100.679L394.393 62.9458L393.45 61.31Z",
    fill: "#B4C9FC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M510.852 208.728V347.747L342.452 445.048V167.079L438.687 190.885L510.852 208.728Z",
    fill: "#F3F6FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M401.591 282.781L426.295 267.157L438.652 274.295L475.765 252.883V295.715L401.591 338.547V282.781Z",
    fill: "url(#paint14_linear_470_219)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M432.479 270.726L475.713 245.711V252.883L438.652 274.294L432.479 270.726Z",
    fill: "url(#paint15_linear_470_219)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M342.452 167.079V445.048L270.287 403.356V125.318L270.322 125.327L342.452 167.079Z",
    fill: "url(#paint16_linear_470_219)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M281.591 238.539V246.86C281.591 248.47 282.452 249.958 283.843 250.759L327.73 276.114C329.234 276.984 331.121 275.896 331.121 274.155V266.357C331.121 264.738 330.26 263.249 328.86 262.44L284.513 236.841C283.217 236.102 281.591 237.042 281.591 238.539Z",
    fill: "#F3F6FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M281.591 261.595V269.916C281.591 271.527 282.452 273.015 283.843 273.816L327.73 299.17C329.234 300.041 331.121 298.953 331.121 297.212V289.413C331.121 287.794 330.26 286.306 328.86 285.496L284.513 259.898C283.217 259.158 281.591 260.098 281.591 261.595Z",
    fill: "#F3F6FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M281.591 287.141V295.462C281.591 297.073 282.452 298.561 283.843 299.362L327.73 324.716C329.234 325.587 331.121 324.499 331.121 322.758V314.959C331.121 313.34 330.26 311.852 328.86 311.042L284.513 285.444C283.217 284.704 281.591 285.644 281.591 287.141Z",
    fill: "#F3F6FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M366.521 534.795L523.991 625.803L622.417 568.923L523.991 512.043V489.29L484.626 466.538L366.521 534.795Z",
    fill: "url(#paint17_linear_470_219)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M523.991 500.719L632.261 563.239L622.417 568.923L523.991 512.043V500.719Z",
    fill: "url(#paint18_linear_470_219)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M576.573 563.918L575.591 562.299L614.06 539.025L615.043 540.644L576.573 563.918Z",
    fill: "url(#paint19_linear_470_219)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M516.6 552.289L515.652 550.653L574.365 516.577L575.313 518.213L516.6 552.289Z",
    fill: "url(#paint20_linear_470_219)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M536.295 495.139L535.321 493.52L564.852 475.747L565.826 477.366L536.295 495.139Z",
    fill: "url(#paint21_linear_470_219)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M487.086 479.472L486.121 477.845L525.486 454.353L526.452 455.98L487.086 479.472Z",
    fill: "url(#paint22_linear_470_219)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M606.052 536.709L620.443 545.03C621.661 545.735 623.165 545.735 624.391 545.03L639.374 536.405C640.617 535.691 640.617 533.889 639.374 533.176L624.374 524.541C623.165 523.845 621.669 523.845 620.461 524.541L606.052 532.871C604.574 533.733 604.574 535.865 606.052 536.709Z",
    fill: "url(#paint23_linear_470_219)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M635.4 519.963L649.791 528.284C651.009 528.989 652.513 528.989 653.739 528.284L668.722 519.658C669.965 518.945 669.965 517.143 668.722 516.429L653.722 507.795C652.513 507.099 651.017 507.099 649.809 507.795L635.4 516.125C633.93 516.986 633.93 519.11 635.4 519.963Z",
    fill: "url(#paint24_linear_470_219)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M665.173 502.59L679.565 510.911C680.782 511.616 682.287 511.616 683.513 510.911L698.495 502.285C699.739 501.572 699.739 499.77 698.495 499.056L683.495 490.422C682.287 489.726 680.791 489.726 679.582 490.422L665.173 498.752C663.704 499.613 663.704 501.746 665.173 502.59Z",
    fill: "url(#paint25_linear_470_219)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M566.765 514.523L581.156 522.844C582.374 523.549 583.878 523.549 585.104 522.844L600.087 514.218C601.33 513.505 601.33 511.703 600.087 510.989L585.087 502.355C583.878 501.659 582.382 501.659 581.174 502.355L566.765 510.685C565.287 511.538 565.287 513.67 566.765 514.523Z",
    fill: "url(#paint26_linear_470_219)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M596.113 497.777L610.504 506.098C611.722 506.803 613.226 506.803 614.452 506.098L629.435 497.472C630.678 496.758 630.678 494.957 629.435 494.243L614.435 485.609C613.226 484.912 611.73 484.912 610.522 485.609L596.113 493.938C594.643 494.791 594.643 496.924 596.113 497.777Z",
    fill: "url(#paint27_linear_470_219)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M557.531 473.832L571.922 482.153C573.139 482.858 574.644 482.858 575.87 482.153L590.852 473.528C592.096 472.814 592.096 471.012 590.852 470.299L575.852 461.664C574.644 460.968 573.148 460.968 571.939 461.664L557.531 469.994C556.052 470.856 556.052 472.979 557.531 473.832Z",
    fill: "url(#paint28_linear_470_219)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M586.887 457.086L601.278 465.407C602.496 466.112 604 466.112 605.226 465.407L620.209 456.781C621.452 456.067 621.452 454.266 620.209 453.552L605.209 444.918C604 444.221 602.504 444.221 601.296 444.918L586.887 453.247C585.409 454.1 585.409 456.233 586.887 457.086Z",
    fill: "url(#paint29_linear_470_219)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M616.66 439.713L631.052 448.034C632.269 448.739 633.774 448.739 635 448.034L649.982 439.408C651.226 438.694 651.226 436.893 649.982 436.179L634.982 427.545C633.773 426.848 632.278 426.848 631.069 427.545L616.66 435.874C615.182 436.736 615.182 438.86 616.66 439.713Z",
    fill: "url(#paint30_linear_470_219)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M646.008 422.966L660.4 431.287C661.617 431.992 663.121 431.992 664.348 431.287L679.33 422.662C680.574 421.948 680.574 420.146 679.33 419.433L664.33 410.798C663.121 410.102 661.626 410.102 660.417 410.798L646.008 419.128C644.539 419.981 644.539 422.113 646.008 422.966Z",
    fill: "url(#paint31_linear_470_219)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M517.304 451.951L531.695 460.271C532.913 460.977 534.417 460.977 535.643 460.271L550.626 451.646C551.869 450.932 551.869 449.13 550.626 448.417L535.626 439.782C534.417 439.086 532.921 439.086 531.713 439.782L517.304 448.112C515.826 448.965 515.826 451.098 517.304 451.951Z",
    fill: "url(#paint32_linear_470_219)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M546.66 435.204L561.052 443.525C562.269 444.23 563.773 444.23 565 443.525L579.982 434.9C581.225 434.186 581.225 432.384 579.982 431.67L564.982 423.036C563.773 422.34 562.278 422.34 561.069 423.036L546.66 431.366C545.182 432.219 545.182 434.351 546.66 435.204Z",
    fill: "url(#paint33_linear_470_219)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M366.521 534.794V545.518L523.991 636.518V625.803L366.521 534.794Z",
    fill: "url(#paint34_linear_470_219)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M523.991 625.803V636.518L622.417 579.637V568.923L523.991 625.803Z",
    fill: "url(#paint35_linear_470_219)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M632.26 573.954V563.239L622.417 568.923V579.637L632.26 573.954Z",
    fill: "url(#paint36_linear_470_219)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M171.304 489.926C171.304 489.926 182.496 501.276 180.417 503.304C178.339 505.332 163.774 497.759 163.313 494.034C162.809 489.978 164.591 489.421 164.591 489.421L168.591 486.688L171.304 489.926Z",
    fill: "#012860"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M184.452 483.624C184.452 483.624 195.643 494.974 193.565 497.002C191.487 499.03 176.921 491.458 176.46 487.732C175.956 483.676 177.739 483.119 177.739 483.119L181.739 480.386L184.452 483.624Z",
    fill: "#012860"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M176.583 430.931L171.304 489.926C171.304 489.926 169.07 491.388 167.226 490.962C165.383 490.535 164.591 489.421 164.591 489.421L166.904 430.878L168.513 425.586L176.583 430.931Z",
    fill: "url(#paint37_linear_470_219)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M189.73 424.629L184.452 483.624C184.452 483.624 182.217 485.086 180.374 484.66C178.539 484.233 177.739 483.119 177.739 483.119L180.052 424.577L181.661 419.285L189.73 424.629Z",
    fill: "url(#paint38_linear_470_219)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M159.791 401.511C159.791 401.511 159.643 408.092 159.035 414.019C158.426 419.946 158.409 430.287 158.409 430.287C158.409 430.287 169.661 432.262 180.296 430.287C190.922 428.311 195.478 424.664 195.478 424.664L191.8 395.21L185.765 392.137L159.791 401.511Z",
    fill: "url(#paint39_linear_470_219)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.878 342.586C192.878 342.586 222.217 332.959 225.052 330.835C227.887 328.711 236.8 327.31 237.2 327.963C237.608 328.607 231.53 330.235 231.121 331.749C230.713 333.272 230.008 337.024 227.278 336.51C224.548 335.997 218.365 337.894 211.991 340.549C205.617 343.204 193.2 348.461 193.2 348.461C193.2 348.461 193.078 346.772 192.878 346.372C192.678 345.954 192.878 342.586 192.878 342.586Z",
    fill: "url(#paint40_linear_470_219)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.443 342.951L191.156 340.41C191.156 340.41 193.035 341.985 194 345.101C194.8 347.686 194.73 350.184 194.73 350.184L189.609 352.325C189.609 352.325 186.809 351.855 186.365 351.629C185.913 351.394 183.443 342.951 183.443 342.951Z",
    fill: "url(#paint41_linear_470_219)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M174.148 339.879C174.148 339.879 162.887 347.286 163.461 358.079C164.043 368.871 164.443 371.152 162.191 376.775C159.939 382.397 158.252 384.069 158.409 391.214C158.565 398.36 159.782 401.511 159.782 401.511C159.782 401.511 171.791 403.069 181.887 399.884C191.982 396.689 193.191 393.652 193.191 393.652C193.191 393.652 188.026 375.826 189.165 370.752C190.304 365.677 193.035 360.968 191.217 356.407C189.391 351.847 186.356 343.047 181.722 342.281C177.087 341.515 174.148 339.879 174.148 339.879Z",
    fill: "url(#paint42_linear_470_219)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M159.869 362.64C159.695 363.78 161.391 366.165 163.6 368.767C167.174 372.91 172.095 377.61 172.93 378.594C173.026 378.716 173.113 378.829 173.182 378.942C174.191 380.404 173.513 381.701 174.156 383.633C174.556 384.852 174.982 386.245 175.261 387.193C175.565 388.212 176.582 388.838 177.643 388.656C178.252 388.56 179.026 388.342 180.026 387.924C184.556 386.088 179.33 380.57 179.33 380.57C179.33 380.57 178.834 379.29 176.33 376.165C176.017 375.774 175.678 375.347 175.287 374.886C171.869 370.839 168.704 367.897 167.182 365.729C167.174 365.703 167.156 365.695 167.147 365.669C165.704 363.519 167.852 361.16 167.852 361.16L166.017 355.189L162.008 357.496C162.008 357.513 160.33 359.671 159.869 362.64Z",
    fill: "url(#paint43_linear_470_219)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M173.53 334.439L173.2 339.383C173.2 339.383 173.365 342.577 174.661 344.762C175.956 346.946 179.582 348.992 179.582 348.992C179.582 348.992 181.617 344.762 181.2 342.029C180.782 339.296 180.791 339.6 181.035 338.469C181.278 337.337 181.182 335.1 181.182 335.1L176.321 331.601L173.53 334.439Z",
    fill: "url(#paint44_linear_470_219)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M186.93 322.532C186.93 322.532 188.165 325.543 187.86 330.409C187.53 335.709 185.087 339.322 185.087 339.322C185.087 339.322 177.93 338.756 175.33 334.587C172.73 330.409 174.695 322.619 174.695 322.619L179.634 319.268L186.93 322.532Z",
    fill: "url(#paint45_linear_470_219)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M169.391 329.782C170.835 332.898 173.174 335.118 175.322 334.587C180.296 333.359 179.8 327.04 181.122 324.412C182.443 321.775 186.93 322.523 186.93 322.523C186.93 322.523 185.313 312.766 174.043 315.69C172.504 316.082 171.304 316.761 170.391 317.614C167.217 320.626 167.6 325.9 169.391 329.782Z",
    fill: "#012860"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M163.608 329.669C163.608 329.669 167.408 331.941 169.391 329.782C167.6 325.9 167.217 320.626 170.391 317.623C170.391 317.623 168 316.291 166.739 317.997C165.495 319.712 167.339 326.884 166.417 328.224C165.478 329.565 163.608 329.669 163.608 329.669Z",
    fill: "#012860"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M166.583 346.058C168.939 343.308 173.461 344.544 174.487 348.017C174.887 349.383 174.974 351.046 174.191 352.856C172.139 357.643 170.583 361.595 170.583 361.595C170.583 361.595 168.852 362.056 165.087 359.846C161.322 357.635 160.904 355.894 160.904 355.894C160.904 355.894 164.174 349.566 166.217 346.528C166.339 346.363 166.452 346.206 166.583 346.058Z",
    fill: "url(#paint46_linear_470_219)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M167.183 365.747C168.704 367.914 171.87 370.856 175.287 374.903C175.678 375.365 176.017 375.791 176.33 376.183L183.835 369.559L174.357 359.393L167.139 365.694C167.157 365.703 167.165 365.721 167.183 365.747Z",
    fill: "url(#paint47_linear_470_219)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M157.887 373.754L166.878 384.513L173.182 378.942C173.113 378.82 173.026 378.707 172.93 378.594C172.095 377.61 167.174 372.919 163.6 368.767L157.887 373.754Z",
    fill: "url(#paint48_linear_470_219)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M269.705 539.956C269.705 539.956 266.844 549.13 272 548.651C277.157 548.172 288.139 542.245 287.661 539.956C287.183 537.658 275.505 539.703 275.505 539.703L271.809 538.337L269.705 539.956Z",
    fill: "url(#paint49_linear_470_219)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M256.47 536.797C256.47 536.797 253.635 545.883 258.739 545.413C263.843 544.943 274.722 539.068 274.252 536.797C273.783 534.525 262.209 536.544 262.209 536.544L258.548 535.186L256.47 536.797Z",
    fill: "url(#paint50_linear_470_219)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M263.13 483.311C263.13 483.311 265.999 493.181 265.669 499.056C265.339 504.931 269.608 541.209 269.608 541.209C269.608 541.209 270.104 542.028 271.852 541.923C273.599 541.81 274.582 540.992 274.582 540.992C274.582 540.992 275.139 483.276 273.704 479.316C272.269 475.364 263.13 477.131 263.13 477.131V483.311Z",
    fill: "url(#paint51_linear_470_219)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M250.261 481.161C250.261 481.161 253.095 490.936 252.774 496.759C252.452 502.582 256.669 538.503 256.669 538.503C256.669 538.503 257.156 539.312 258.887 539.208C260.617 539.103 261.591 538.285 261.591 538.285C261.591 538.285 262.139 481.126 260.721 477.21C259.304 473.293 250.252 475.051 250.252 475.051V481.161H250.261Z",
    fill: "url(#paint52_linear_470_219)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M281.165 483.146C281.165 483.146 277.06 481.257 273.947 481.353C267.139 481.553 267.878 483.389 260.66 483.746C253.547 484.094 246.234 479.168 246.234 479.168C246.269 478.237 244.434 475.103 246.147 468.949C247.747 463.231 247.034 461.125 246.312 458.287C247.599 456.921 249.721 455.545 252.956 456.233C258.765 457.46 269.139 454.353 269.139 454.353L269.13 454.344C265.538 455.058 261.278 455.302 256.808 454.257C255.434 453.935 254.208 453.613 253.095 453.282C249.443 452.22 247.156 451.159 245.747 450.306C245.747 450.306 247.565 450.158 250.295 449.931C253.678 449.661 258.469 449.279 262.921 448.965C268.938 448.521 274.347 448.199 274.834 448.365C275.982 448.765 277.947 451.35 277.947 451.35L281.165 483.146Z",
    fill: "url(#paint53_linear_470_219)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M246.765 396.393C246.765 396.393 238.452 411.73 238.939 418.057C239.434 424.385 255.582 427.197 255.582 427.197L254.843 410.868L246.765 396.393Z",
    fill: "url(#paint54_linear_470_219)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M269.992 371.7C269.992 371.7 272.974 376.13 272.244 377.715C271.887 378.489 275.131 382.859 273 384.338C270.087 386.366 265.618 386.088 260.922 382.31C256.226 378.533 259.174 371.7 259.174 371.7L264.035 367.653L269.992 371.7Z",
    fill: "url(#paint55_linear_470_219)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M293.782 389.16C293.782 389.16 298.313 376.81 299.095 377.593C299.878 378.376 298.139 382.319 299.539 383.947C300.939 385.574 302.791 386.314 300.965 388.612C299.139 390.91 294.165 393.643 294.165 393.643L293.782 389.16Z",
    fill: "url(#paint56_linear_470_219)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M283.835 419.955C277.435 416.682 275.009 412.295 274.713 411.73C274.904 412.182 276.139 415.237 275.478 416.752C275.261 417.248 274.939 417.7 274.626 418.153C274.626 418.153 274.6 418.197 274.556 418.258C274.522 418.301 274.487 418.345 274.461 418.379C274.443 418.414 274.417 418.449 274.391 418.484C273.748 419.433 273.226 420.486 273.722 422.174C274.2 423.793 275.095 425.421 276.026 428.189C276.035 428.197 276.035 428.197 276.035 428.197C276.661 430.06 277.295 432.445 277.817 435.692C279.113 443.751 279.278 450.645 279.278 450.645C279.278 450.645 278.809 450.923 277.965 451.35C276.296 452.177 273.13 453.552 269.139 454.335C265.548 455.049 261.287 455.293 256.817 454.248C255.443 453.926 254.217 453.604 253.104 453.273C249.452 452.212 247.165 451.15 245.756 450.297C243.869 449.157 243.53 448.356 243.53 448.356C243.53 448.356 243.635 447.381 243.809 445.814C244.356 440.905 245.6 430.173 246.6 425.525C247.461 421.522 246.469 416.282 245.756 410.755C245.374 407.83 245.078 404.81 245.174 401.868C245.53 390.849 258.782 390.422 258.782 390.422C258.782 390.422 268.33 389.918 273.722 397.142C277.365 402.016 280.678 405.297 282.817 406.133C283.843 406.551 284.6 406.385 284.982 405.567C285.235 405.028 285.687 403.818 286.278 402.268C286.287 402.26 286.287 402.26 286.287 402.251C288.478 396.515 292.6 386.166 295.826 388.325C299.939 391.066 290.687 423.454 283.835 419.955Z",
    fill: "url(#paint57_linear_470_219)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M266.486 440.635C266.486 440.635 269.93 440.087 271.573 439.321C273.217 438.555 274.852 436.753 274.852 436.753C274.852 436.753 274.069 439.817 272.678 441.375C271.286 442.933 270.878 443.099 270.878 443.099C270.878 443.099 271.634 440.47 270.191 440.679C268.747 440.879 266.486 440.635 266.486 440.635Z",
    fill: "url(#paint58_linear_470_219)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M276.026 428.189C275.835 427.98 272.531 424.324 270.383 423.732C268.165 423.114 268.287 422.949 270.661 421.765C272.496 420.843 273.861 419.198 274.383 418.493C273.739 419.441 273.218 420.495 273.713 422.183C274.2 423.793 275.105 425.421 276.026 428.189Z",
    fill: "url(#paint59_linear_470_219)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M255.582 435.134C252.574 437.685 249.513 440.67 248.148 443.325C247.122 445.292 247.043 447.085 248.617 448.373C249.217 448.861 249.782 449.392 250.313 449.931C251.417 451.063 252.365 452.264 253.104 453.282C249.452 452.22 247.165 451.158 245.756 450.305C243.869 449.165 243.53 448.364 243.53 448.364C243.53 448.364 243.635 447.39 243.809 445.823C244.356 440.914 245.6 430.182 246.6 425.534C247.461 421.53 246.469 416.29 245.756 410.763C245.756 410.763 253.374 416.029 251.322 418.484C249.269 420.938 247.791 425.743 249.843 427.205C251.896 428.659 260.826 430.713 255.582 435.134Z",
    fill: "url(#paint60_linear_470_219)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M286.165 407.282C286.33 408.796 282.817 406.15 282.817 406.15V406.142C283.843 406.559 284.6 406.394 284.983 405.576C285.235 405.036 285.687 403.826 286.278 402.277C285.835 403.435 286 405.767 286.165 407.282Z",
    fill: "url(#paint61_linear_470_219)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M269.147 454.353C269.147 454.353 258.782 457.46 252.965 456.233C249.73 455.554 247.608 456.921 246.321 458.287C246.269 458.078 246.208 457.852 246.156 457.634C245.391 454.44 245.756 450.314 245.756 450.314C247.165 451.176 249.452 452.229 253.104 453.291C254.208 453.622 255.443 453.944 256.817 454.266C261.286 455.302 265.547 455.058 269.147 454.353Z",
    fill: "url(#paint62_linear_470_219)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M269.991 371.7C269.991 371.7 265.852 372.51 267.722 378.35C269.592 384.182 271.47 386.967 268.618 389.021C265.757 391.075 267.139 392.712 267.913 394.6C269.687 398.874 270.348 405.82 260.913 405.08C251.478 404.34 243.365 399.344 246.044 392.39C247.539 388.516 253.583 386.81 250.418 383.964C248.774 382.485 248.748 378.054 250.418 373.354C252.574 367.253 256.131 363.179 262.635 364.163C269.131 365.138 269.991 371.7 269.991 371.7Z",
    fill: "#012860"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M227.096 208.954C227.096 208.954 228.035 267.288 228.461 322.088C228.461 322.088 229.426 233.813 229.826 208.954H227.096Z",
    fill: "url(#paint63_linear_470_219)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M228.461 211.06C234.037 211.06 238.557 206.536 238.557 200.955C238.557 195.374 234.037 190.85 228.461 190.85C222.885 190.85 218.365 195.374 218.365 200.955C218.365 206.536 222.885 211.06 228.461 211.06Z",
    fill: "url(#paint64_linear_470_219)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M727.878 251.542C727.878 251.542 728.817 356.077 729.243 454.292C729.243 454.292 730.208 296.098 730.608 251.542H727.878Z",
    fill: "url(#paint65_linear_470_219)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M729.243 253.658C734.819 253.658 739.339 249.133 739.339 243.552C739.339 237.971 734.819 233.447 729.243 233.447C723.667 233.447 719.147 237.971 719.147 243.552C719.147 249.133 723.667 253.658 729.243 253.658Z",
    fill: "url(#paint66_linear_470_219)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M212.365 486.914C212.365 486.914 213.304 545.248 213.73 600.048C213.73 600.048 214.696 511.773 215.096 486.914H212.365Z",
    fill: "url(#paint67_linear_470_219)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M213.73 489.029C219.306 489.029 223.826 484.505 223.826 478.924C223.826 473.343 219.306 468.819 213.73 468.819C208.155 468.819 203.635 473.343 203.635 478.924C203.635 484.505 208.155 489.029 213.73 489.029Z",
    fill: "url(#paint68_linear_470_219)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_470_219",
    x1: 44.3489,
    y1: 488.857,
    x2: 213.731,
    y2: 488.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_470_219",
    x1: 263.693,
    y1: 564.693,
    x2: 525.634,
    y2: 564.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_470_219",
    x1: 362.669,
    y1: 381.641,
    x2: 538.751,
    y2: 381.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_470_219",
    x1: 199.073,
    y1: 341.957,
    x2: 311.853,
    y2: 341.957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_470_219",
    x1: 0.173735,
    y1: 290.373,
    x2: 187.568,
    y2: 290.373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_470_219",
    x1: 43.382,
    y1: 245.081,
    x2: 43.4242,
    y2: 365.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004DAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00276A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_470_219",
    x1: 80.3976,
    y1: 196.565,
    x2: 79.7989,
    y2: 353.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_470_219",
    x1: 117.371,
    y1: 263.859,
    x2: 120.244,
    y2: 336.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_470_219",
    x1: 154.365,
    y1: 272.635,
    x2: 155.891,
    y2: 310.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAAAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_470_219",
    x1: 270.325,
    y1: 158.103,
    x2: 438.682,
    y2: 158.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_470_219",
    x1: 294.328,
    y1: 187.847,
    x2: 438.677,
    y2: 187.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_470_219",
    x1: 318.401,
    y1: 215.674,
    x2: 462.751,
    y2: 215.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_470_219",
    x1: 438.682,
    y1: 187.847,
    x2: 510.853,
    y2: 187.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_470_219",
    x1: 354.474,
    y1: 236.522,
    x2: 498.824,
    y2: 236.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_470_219",
    x1: 401.589,
    y1: 295.715,
    x2: 475.765,
    y2: 295.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_470_219",
    x1: 432.475,
    y1: 260.004,
    x2: 475.713,
    y2: 260.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_470_219",
    x1: 270.288,
    y1: 285.183,
    x2: 342.449,
    y2: 285.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_470_219",
    x1: 366.519,
    y1: 546.173,
    x2: 622.414,
    y2: 546.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_470_219",
    x1: 523.988,
    y1: 534.821,
    x2: 632.257,
    y2: 534.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_470_219",
    x1: 575.595,
    y1: 551.473,
    x2: 615.041,
    y2: 551.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_470_219",
    x1: 515.656,
    y1: 534.436,
    x2: 575.313,
    y2: 534.436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_470_219",
    x1: 535.324,
    y1: 485.445,
    x2: 565.826,
    y2: 485.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_470_219",
    x1: 486.123,
    y1: 466.913,
    x2: 526.451,
    y2: 466.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAC9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_470_219",
    x1: 604.942,
    y1: 534.794,
    x2: 640.304,
    y2: 534.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_470_219",
    x1: 634.298,
    y1: 518.045,
    x2: 669.66,
    y2: 518.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_470_219",
    x1: 664.071,
    y1: 500.675,
    x2: 699.433,
    y2: 500.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_470_219",
    x1: 565.656,
    y1: 512.603,
    x2: 601.018,
    y2: 512.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_470_219",
    x1: 595.011,
    y1: 495.854,
    x2: 630.374,
    y2: 495.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_470_219",
    x1: 556.423,
    y1: 471.915,
    x2: 591.785,
    y2: 471.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_470_219",
    x1: 585.778,
    y1: 455.167,
    x2: 621.141,
    y2: 455.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_470_219",
    x1: 615.551,
    y1: 437.796,
    x2: 650.913,
    y2: 437.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_470_219",
    x1: 644.907,
    y1: 421.048,
    x2: 680.269,
    y2: 421.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_470_219",
    x1: 516.199,
    y1: 450.032,
    x2: 551.561,
    y2: 450.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_470_219",
    x1: 545.554,
    y1: 433.283,
    x2: 580.916,
    y2: 433.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4833,
    stopColor: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_470_219",
    x1: 366.519,
    y1: 585.659,
    x2: 523.987,
    y2: 585.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_470_219",
    x1: 523.988,
    y1: 602.722,
    x2: 622.414,
    y2: 602.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_470_219",
    x1: 622.414,
    y1: 571.438,
    x2: 632.257,
    y2: 571.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_470_219",
    x1: 176.581,
    y1: 458.304,
    x2: 164.59,
    y2: 458.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_470_219",
    x1: 189.73,
    y1: 452.003,
    x2: 177.739,
    y2: 452.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_470_219",
    x1: 158.41,
    y1: 411.648,
    x2: 195.481,
    y2: 411.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_470_219",
    x1: 237.222,
    y1: 338.123,
    x2: 192.791,
    y2: 338.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_470_219",
    x1: 194.723,
    y1: 346.361,
    x2: 183.44,
    y2: 346.361,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_470_219",
    x1: 193.203,
    y1: 370.889,
    x2: 158.41,
    y2: 370.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_470_219",
    x1: 181.87,
    y1: 371.949,
    x2: 159.854,
    y2: 371.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_470_219",
    x1: 181.252,
    y1: 340.306,
    x2: 173.198,
    y2: 340.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_470_219",
    x1: 187.903,
    y1: 329.298,
    x2: 173.974,
    y2: 329.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_470_219",
    x1: 174.787,
    y1: 353.094,
    x2: 160.907,
    y2: 353.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_470_219",
    x1: 183.836,
    y1: 367.78,
    x2: 167.144,
    y2: 367.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_470_219",
    x1: 173.182,
    y1: 376.645,
    x2: 157.886,
    y2: 376.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F22AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C00E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_470_219",
    x1: 268.909,
    y1: 543.503,
    x2: 287.67,
    y2: 543.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_470_219",
    x1: 255.683,
    y1: 540.308,
    x2: 274.263,
    y2: 540.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003A7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_470_219",
    x1: 263.131,
    y1: 509.335,
    x2: 274.685,
    y2: 509.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_470_219",
    x1: 250.262,
    y1: 506.93,
    x2: 261.704,
    y2: 506.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_470_219",
    x1: 245.421,
    y1: 466.041,
    x2: 281.167,
    y2: 466.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_470_219",
    x1: 238.921,
    y1: 411.798,
    x2: 255.584,
    y2: 411.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9EFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_470_219",
    x1: 258.251,
    y1: 376.623,
    x2: 273.725,
    y2: 376.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_470_219",
    x1: 293.778,
    y1: 385.591,
    x2: 301.729,
    y2: 385.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7F83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD4D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_470_219",
    x1: 243.534,
    y1: 421.501,
    x2: 296.843,
    y2: 421.501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_470_219",
    x1: 266.489,
    y1: 439.925,
    x2: 274.851,
    y2: 439.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005EFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_470_219",
    x1: 268.801,
    y1: 423.337,
    x2: 276.026,
    y2: 423.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_470_219",
    x1: 243.534,
    y1: 432.026,
    x2: 257.21,
    y2: 432.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00126202,
    stopColor: "#94B9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4379,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7226,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_470_219",
    x1: 282.82,
    y1: 405.009,
    x2: 286.277,
    y2: 405.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_470_219",
    x1: 245.669,
    y1: 454.294,
    x2: 269.145,
    y2: 454.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002294"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_470_219",
    x1: 227.094,
    y1: 265.523,
    x2: 229.821,
    y2: 265.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_470_219",
    x1: 238.55,
    y1: 200.959,
    x2: 218.366,
    y2: 200.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_470_219",
    x1: 727.882,
    y1: 352.919,
    x2: 730.609,
    y2: 352.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_470_219",
    x1: 739.338,
    y1: 243.549,
    x2: 719.154,
    y2: 243.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_470_219",
    x1: 212.367,
    y1: 543.485,
    x2: 215.094,
    y2: 543.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_470_219",
    x1: 223.823,
    y1: 478.92,
    x2: 203.639,
    y2: 478.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2774,
    stopColor: "#C7DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5621,
    stopColor: "#ABC8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#9ABDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#94B9FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls15);
export default __webpack_public_path__ + "static/media/ils_15.c6847d8ca23a9f8b16db59a934e29a19.svg";
export { ForwardRef as ReactComponent };